import { FormattedMessage } from "react-intl";

import { Button, ButtonProps } from "ui/Button/Button";

type SkipScanningButtonProps = {
  onClickSkipButton: () => void;
} & ButtonProps;

export function SkipScanningButton({ onClickSkipButton, ...rest }: SkipScanningButtonProps) {
  return (
    <Button variant="link" size="lg" onClick={onClickSkipButton} {...rest}>
      <FormattedMessage id="components.picking.skip-scanning-button.label" />
    </Button>
  );
}
